<div class="formly-field-wrap">
  @if(!options.formState.disabled && !field.props['disabled'] && !field.props['readonly']) {
    <input
      class="active-input"
      [class.error]="formControl.invalid"
      type="email"
      inputmode="email"
      autocomplete="email"
      spellcheck="false"
      [attr.multiple]="field.props['multiple'] ? '' : null"
      [min]="field.props.min || null"
      [max]="field.props.max || null"
      placeholder="{{field.props.placeholder || field.props.label || '' | translate}}"
      [formControl]="$any(formControl)"
      [formlyAttributes]="field"
      (input)="onValueChange($event)">
    @if (field.props['maxLength']) {
      <div class="char-counter">
        {{ getCharacterCount() }}/{{ getMaxLength() }}
      </div>
    }
  } @else {
    <div [class]="(options.formState.showCompactViewWhenDisabled ? 'compact-' : '') + 'disabled-text'">
      {{ formControl.value || "" }}
    </div>
  }
  <ng-template #fieldComponent></ng-template>
</div>